import { CALCULATE_LOAN, ERR_CALCULATE_LOAN } from "actions/types";
export default (state = null, action) => {
  switch (action.type) {
    case CALCULATE_LOAN:
      state = action.payload;
      return {
        data: state,
        alert: {
          message: "Yazı Eklendi !",
          type: "success"
        }
      };
    case ERR_CALCULATE_LOAN:
      return {
        data: state,
        alert: {
          message: "Onaylama Hatası !",
          type: "err"
        }
      };
    default:
      return state;
  }
};
